import {createFileRoute} from '@tanstack/react-router';
import {StatementPaymentSelectPage} from 'features/statement-payment/pages/StatementPaymentSelectPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/_payment/select',
)({
  component: StatementPaymentSelectPage,
});
